import { RESERVED_ORG_IDS } from '@/state';
import { CustomerDomainOrg } from '@/state/types';

// defined individually to avoid undefined typing issues
export const NO_ORG_FILTER: CustomerDomainOrg = {
	orgId: RESERVED_ORG_IDS.NO_ORG,
	orgName: 'No Org', // do not display this name on UI
};

export const OTHER_ORG_FILTER: CustomerDomainOrg = {
	orgId: RESERVED_ORG_IDS.OTHER_ORGS,
	orgName: 'Other Cloud Orgs', // do not display this name on UI
};

export const DEFAULT_ORG_FILTERS_ORDER: CustomerDomainOrg[] = [OTHER_ORG_FILTER, NO_ORG_FILTER];
